var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('aside-menu'),_c('top-menu'),_c('v-content',[_c('v-container',{staticClass:"px-3",attrs:{"grid-list-md":""}},[_c('router-view')],1)],1),_c('v-footer',{attrs:{"app":"","fixed":"","dark":""}},[_c('span',[_vm._v("© Version: "+_vm._s(_vm.nucleus.appVersion))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }